import {React,useState,useEffect} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SlickSlider.css";
import axios from "axios";

const SlickSlider = () => {
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
   const [images, setImages] = useState([]);

   useEffect(() => {
    fetchCarouselImages();
  }, []);

  const fetchCarouselImages = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/filelist`);
      setImages(response.data);
    } catch (error) {
      console.error('Error fetching carousel images:', error);
    }
  };

   

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    };

  // const images = [
    // "https://palliativecaremanjeri.com/backend/public/storage/carousel/sGLUkgSJzrThU8lhdCEGQ2B0KwXyriRsXKOdlZYF.jpg",
    //  require("../images/pal-hero.jpg"),
    // require("../images/carousel/1.jpg"),
    //    require("../images/carousel/2.jpg"),
    //       require("../images/carousel/3.jpg"),
    //       require("../images/carousel/4.jpg"),

       
  // ];

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="slide-wrapper">
            <img 
              src={image} 
              alt={`Slide ${index + 1}`}
              className="slider-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SlickSlider;